// ABOUTME: Composable for the one-time notice about the MyStekz -> Gotoko rebrand
// ABOUTME: Triggered by the legacy-redirect marker; the user is signed out at
// that point, so "seen" is tracked per-browser (localStorage), not per-account.
import { useDialog } from "primevue/usedialog";

import RebrandNotice from "@/components/dialogs/RebrandNotice.vue";
import { arrivedViaLegacyRedirect } from "@/lib/rebrand-redirect";

const STORAGE_KEY = "gotoko-rebrand-notice-seen";

const hasSeenNotice = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
};

const markNoticeSeen = (): void => {
    try {
        localStorage.setItem(STORAGE_KEY, "1");
    } catch {
        // Private browsing / blocked storage: nothing to persist, the notice
        // may show again next visit. Not worth failing the flow over.
    }
};

export const useRebrandNotice = () => {
    const dialog = useDialog();

    const checkAndShowRebrandNotice = (): void => {
        if (!arrivedViaLegacyRedirect || hasSeenNotice()) return;

        dialog.open(RebrandNotice, {
            props: {
                modal: true,
                header: "We've rebranded",
                style: { width: "440px" },
            },
            onClose: () => markNoticeSeen(),
        });
    };

    return { checkAndShowRebrandNotice };
};
